import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/vendora.webp';
import screenshot_target from '../../../images/letterfunnel/robinschuil.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Robin Schuil"
      firstname="Robin"
      companyname="Vendora"
      competition="Xe.gr en Vinted"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/robinschuil.js